const ScrollLinkEnum = Object.freeze({
    HOME: "HOME",
    ABOUT: "ABOUT",
    PURCHASE: "PURCHASE",
    ROADMAP: "ROADMAP",
    FAQ: "FAQ",
    NONE: "NONE"
})

export default ScrollLinkEnum;